import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ENV_CONFIG } from '@ps/core-config';
import { withLoading } from '@ps/core-overlay';
import { SupplierGroupTemplateDto } from './dtos/supplier-group-template.dto';
import { SupplierGroupTemplateMapper } from './mappers/supplier-group-template.mapper';
import { SupplierGroupTemplatePayloadMapper } from './mappers/supplier-group-template-payload.mapper';
import {
  SupplierGroupTemplate,
  SupplierGroupTemplateSave,
} from '../models/supplier-group-template.model';

@Injectable({ providedIn: 'root' })
export class SupplierGroupTemplateApi {
  private readonly _http = inject(HttpClient);
  private readonly _envConfig = inject(ENV_CONFIG);
  private readonly _mapper = new SupplierGroupTemplateMapper();
  private readonly _payloadMapper = new SupplierGroupTemplatePayloadMapper();

  private readonly _baseUrl = `${this._envConfig.pureSpectrum.url}/buyers/v2/supplier-group-template`;

  public getAll(): Observable<SupplierGroupTemplate[]> {
    return this._http
      .get<SupplierGroupTemplateDto[]>(this._baseUrl, {
        context: withLoading('page'),
      })
      .pipe(map((dtos) => this._mapper.fromDtoList(dtos)));
  }

  public save(data: SupplierGroupTemplateSave): Observable<void> {
    const payload = this._payloadMapper.toPayload(data);
    return this._http
      .post(this._baseUrl, payload, {
        context: withLoading('page'),
      })
      .pipe(map(() => undefined));
  }
}
